/**
 * @hidden
 */
var Mask = function () {
  function Mask() {
    this.symbols = '';
  }

  return Mask;
}();

export { Mask };